// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"tiles_wrapper__iQ18V","text":"tiles_text__IRTIN","title":"tiles_title__lJ8Ii","grid":"tiles_grid__BLVRf","item":"tiles_item__YZlLR"};